import { screens } from "../../tailwind.config.js";

/**
 * The Tailwind breakpoints (`tablet`/`desktop`/`desktopLg`) as numbers, for
 * runtime width checks - read from tailwind.config.js so they can't drift.
 */
export const breakpoints = {
  tablet: parseInt(screens.tablet),
  desktop: parseInt(screens.desktop),
  desktopLg: parseInt(screens.desktopLg),
};
